import WpForm from './wp-form';

new WpForm();
